module.exports = __webpack_public_path__ + "img/467dc40012b1d37847db1b6c59ab419f.png";